import { createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import logger from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import _ from 'lodash';

import rootReducer, { persistThisReducers } from '../reducers';
import { saveState } from '../reducers/localStorage';

const middleware = applyMiddleware(ReduxThunk);
const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'temp',
  storage,
  whitelist: persistThisReducers // only these will get persisted
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, reduxDevTools(middleware));
store.subscribe(() => {
  saveState(store.getState());
});

const persistedStore = persistStore(store);

export default store;
export { persistedStore };
